import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Visitor } from 'src/app/admin/models/visitor';
import { VisitorService } from 'src/app/admin/services/visitor.service';

@Component({
  selector: 'app-edit-visitor-modal',
  templateUrl: './edit-visitor-modal.component.html',
  styleUrls: ['./edit-visitor-modal.component.scss'],
})
export class EditVisitorModalComponent implements OnInit {
  visitor: Visitor;
  itemsPerPage: number = 20;
  usernameQuery: string = '';
  fullNameQuery: string = '';
  emailQuery: string = '';
  phoneQuery: string = '';
  visitorStatusQuery: string = '';
  currentPage: number = 1;
  onlyChildren: boolean = false;
  marketingMessageQuery: string = '';
  dateBirthFromQuery:string=''
  dateBirthToQuery:string=''
  registrationDateFromQuery:string=""
  registrationDateToQuery:string=""
   visitorBirthMonthFromQuery:string=""
   visitorBirthMonthToQuery:string=""
  visitorBirthYearFromQuery:string=""
  visitorBirthYearToQuery:string=""
  constructor(private modalController: ModalController, private visitorService: VisitorService) { }

  ngOnInit() { }

  dismissModal() {
    this.modalController.dismiss();
  }

  editVisitor() {
    this.visitorService.editVisitor(this.visitor).subscribe((res) => {
      this.visitorService.getAllVisitorsSearch({
        currentPage: this.currentPage, itemsPerPage: this.itemsPerPage, fullNameQuery: this.fullNameQuery,
        emailQuery: this.emailQuery, phoneQuery: this.phoneQuery, visitorStatusQuery: this.visitorStatusQuery,
         onlyChildren: this.onlyChildren,
          marketingMessageQuery: this.marketingMessageQuery,dateBirthFromQuery:this.dateBirthFromQuery, dateBirthToQuery:this.dateBirthToQuery,          
      registrationDateFromQuery:this.registrationDateFromQuery, registrationDateToQuery:this.registrationDateToQuery,
       visitorBirthMonthFromQuery:this.visitorBirthMonthFromQuery,visitorBirthMonthToQuery:this. visitorBirthMonthToQuery,
       visitorBirthYearFromQuery:this.visitorBirthYearFromQuery,visitorBirthYearToQuery:this. visitorBirthYearToQuery
   
      
      });
      this.dismissModal();
    }, (err) => {
      console.error(err);
    });
  }

}
